export default __webpack_public_path__ + "static/blog-02-1170x600-471bf64cc2f6af03bb1dc513e5d703c2.jpg";